import React, { useState } from 'react';
import dayjs from 'dayjs';
import classNames from 'classnames';
import Box from '@mui/material/Box';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import Modal from '../../../components/Modal';
import Button from '../../../components/Button';
import Card from '../../../components/Card';
import Loading from '../../../components/Loading';
import Pagination from '../../../components/Pagination';
import { ROUTES } from '../../../constants/routes';
import { removeVietnameseTones } from '../../../utils/helpers';

import * as TextareaStyles from '../../../components/Textarea/Textarea.styles';

const RelatedStock = ({ news }) => {
  if (!news.machungkhoan) {
    return null;
  }
  const stocks = JSON.parse(news.machungkhoan);
  return stocks.map((stock) => {
    const company = news.companies.find((c) => c.machungkhoan === stock);
    return (
      <a
        href={`${company?.machungkhoan?.toLowerCase()}-${removeVietnameseTones(
          company?.name
        )}`}
        title={`${company?.name}  | Mã chứng khoán: ${stock}`}
        key={`mlq_${stock}`}
        className="mlq"
      >
        {stock}
      </a>
    );
  });
};

const googleAddCounter = 2;

export default function List({
  isLoading,
  news,
  totalPage,
  currentPage,
  onPageChange,
}) {
  const [selectedNews, setSelectedNews] = useState(null);

  const getShareContent = () => {
    if (!selectedNews) {
      return '';
    }
    const stocks = selectedNews.machungkhoan
      ? JSON.parse(selectedNews.machungkhoan)
      : [];

    return `#tinchungkhoan | ${selectedNews?.title.replace(
      /&nbsp;/g,
      ''
    )}\n#cophieu ${stocks?.length ? '#' : ''}${stocks?.join(' #')}\n\n${
      document.location.origin
    }${ROUTES.newsStockMarket}?id=${selectedNews?.alias_code}`;
  };

  const copyTextToClipboard = async () => {
    const text = getShareContent();
    if (text) {
      await navigator.clipboard.writeText(text);
    }
  };

  return (
    <Card
      title={`Tin chứng khoán ${news?.length ? 'ngày ' + news[0]?.date : ''}`}
      className="sector-item"
    >
      <Box>
        <div
          className={classNames(
            'relative w-full',
            news?.length > 0 ? 'min-h-[65px]' : ''
          )}
        >
          <Loading isLoading={isLoading} className="white" />
          {!news?.length ? (
            <div className="flex w-full min-h-[350px]">
              <div className="w-full text-gray-600 dark:text-gray-300 text-center pt-5 px-0 m-auto">
                <i className="ri-align-justify text-3xl leading-none"></i>
                <p className="m-0 p-0 mt-1 text-sm">Chưa có dữ liệu</p>
              </div>
            </div>
          ) : (
            <Box className="text-xs">
              <div className="flex flex-col justify-between">
                {news?.map((item, index) => (
                  <div key={item.date}>
                    {index > 0 ? (
                      <div className="font-bold text-sm mb-4 mt-4">
                        Tin chứng khoán ngày {item.date}
                      </div>
                    ) : null}
                    <ul className="mt-2 grid-cols-1 gap-2 news-list">
                      {item.news.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <li className="text-sm">
                              <a
                                href={`${ROUTES.newsStockMarket}?id=${item.alias_code}`}
                                target="_blank"
                                className="hover:underline transition ease-in-out duration-200 text-purple-600"
                                title={item.title.replace(/&nbsp;/g, '')}
                              >
                                <span>{item.title.replace(/&nbsp;/g, '')}</span>
                              </a>
                              {item.publishedAt ? (
                                <span>
                                  {' '}
                                  -{' '}
                                  {['vneconomy.vn'].includes(item.source)
                                    ? dayjs(Number(item.publishedAt)).format(
                                        'DD/MM/YYYY'
                                      )
                                    : dayjs(Number(item.publishedAt)).format(
                                        'DD/MM/YYYY HH:mm'
                                      )}
                                </span>
                              ) : null}
                              <span> - Nguồn: {item.source}</span>
                              {item?.machungkhoan ? (
                                <div
                                  className="text-xs text-left"
                                  style={{ marginTop: '5px' }}
                                >
                                  Mã liên quan: <RelatedStock news={item} />
                                  <Button
                                    className="small tag"
                                    sx={{ ml: '8px' }}
                                    onClick={() => setSelectedNews(item)}
                                  >
                                    Chia sẻ
                                  </Button>
                                </div>
                              ) : (
                                <div
                                  className="text-xs text-left"
                                  style={{ marginTop: '5px' }}
                                >
                                  <Button
                                    className="small tag"
                                    onClick={() => setSelectedNews(item)}
                                  >
                                    Chia sẻ
                                  </Button>
                                </div>
                              )}
                            </li>
                          </React.Fragment>
                        );
                      })}
                    </ul>
                  </div>
                ))}
              </div>
              <div className="flex justify-end mt-3">
                <Pagination
                  totalPage={totalPage}
                  defaultPage={currentPage}
                  onChange={onPageChange}
                />
              </div>
            </Box>
          )}
        </div>
      </Box>
      <Modal
        isOpen={!!selectedNews}
        onCloseModal={() => setSelectedNews(null)}
        contentClassName="max-w-[96%] md:max-w-md m-auto w-full"
        title="Chia sẻ"
        mainContentClassName="modal-center max-w-[90vw] sm:max-w-[580px]"
        childrenClassName="mt-2 mb-3"
      >
        {selectedNews ? (
          <div className="relative">
            <TextareaStyles.Textarea
              defaultValue={getShareContent()}
              rows={7}
              multiline
            />
            <Tooltip title="Sao chép">
              <IconButton
                className="bottom-1 right-1 z-10"
                sx={{ position: 'absolute' }}
                onClick={copyTextToClipboard}
              >
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </div>
        ) : null}
      </Modal>
    </Card>
  );
}
